export default function setAvaliableOrganizations(availableOrganizationsVar) {
    return function (organizations) {
        availableOrganizationsVar(organizations);
    };
}
